/* PDP "КУПИТИ КОМПЛЕКТОМ" block.

   Adds the current product AND its paired product to the cart in one request,
   then refreshes and opens the side drawer — the same three steps the PDP's own
   "ДОДАТИ ДО КОШИКА" handler uses (add → re-render #overlay-cart from a fresh
   "/" fetch → click the cart trigger), so both paths leave the drawer in an
   identical state.

   The block never touches the "КУПИТИ" button. That one is intercepted at
   capture phase by snippets/kasa17-checkout.liquid, and preventing its default
   would push the buyer into Shopify's own checkout.

   Prices shown here are display-only arithmetic. The real discount comes from
   an automatic discount rule in Shopify and is applied by the cart — which is
   why the block links its percentage to a theme setting the merchant is told
   to keep in sync, rather than pretending to be the source of truth.
*/
(function () {
  var root = document.querySelector('[data-bundle]');
  if (!root) return;

  var section = root.closest('.section-durnev-product') || document;
  var partnerSel = root.querySelector('[data-bundle-variant]');
  var partnerPriceEl = root.querySelector('[data-bundle-partner-price]');
  var wasEl = root.querySelector('[data-bundle-was]');
  var nowEl = root.querySelector('[data-bundle-now]');
  var addBtn = root.querySelector('[data-bundle-add]');
  var mainIdInput = section.querySelector ? section.querySelector('[data-variant-id]') : null;

  var discount = parseFloat(root.getAttribute('data-bundle-discount')) || 0;

  // Main-product variant prices, straight from the JSON the section already
  // embeds for the Meta Pixel — no extra request, always in sync with Liquid.
  var mainVariants = [];
  try {
    var raw = document.querySelector('[data-product-variants]');
    if (raw) mainVariants = JSON.parse(raw.textContent);
  } catch (e) {}

  // Money formatting is derived from a sample the theme rendered through its
  // own filters, so the block can't drift from the currency/format used
  // everywhere else (e.g. "1234₴" → prefix "", suffix "₴").
  var money = (function () {
    var sample = root.getAttribute('data-money-sample') || '1234';
    var parts = sample.split('1234');
    var pre = parts[0] || '';
    var post = parts.length > 1 ? parts[1] : '';
    return function (cents) { return pre + Math.round(cents / 100) + post; };
  })();

  function mainVariantId() {
    return mainIdInput && mainIdInput.value ? String(mainIdInput.value) : '';
  }

  function mainPrice() {
    var id = mainVariantId();
    for (var i = 0; i < mainVariants.length; i++) {
      if (String(mainVariants[i].id) === id) return mainVariants[i].price;
    }
    return mainVariants.length ? mainVariants[0].price : 0;
  }

  function mainAvailable() {
    var id = mainVariantId();
    for (var i = 0; i < mainVariants.length; i++) {
      if (String(mainVariants[i].id) === id) return mainVariants[i].available !== false;
    }
    return true;
  }

  function partnerOption() {
    if (!partnerSel) return null;
    if (partnerSel.tagName === 'SELECT') return partnerSel.options[partnerSel.selectedIndex] || null;
    return partnerSel; // hidden input — single-variant partner
  }

  function partnerPrice() {
    var opt = partnerOption();
    return opt ? parseInt(opt.getAttribute('data-price'), 10) || 0 : 0;
  }

  function partnerVariantId() {
    return partnerSel && partnerSel.value ? String(partnerSel.value) : '';
  }

  function render() {
    var full = mainPrice() + partnerPrice();
    var final = discount > 0 ? Math.round(full * (100 - discount) / 100) : full;

    if (partnerPriceEl) partnerPriceEl.textContent = money(partnerPrice());
    if (nowEl) nowEl.textContent = money(final);
    if (wasEl) {
      if (discount > 0 && final < full) {
        wasEl.textContent = money(full);
        wasEl.hidden = false;
      } else {
        wasEl.hidden = true;
      }
    }

    // A sold-out main variant makes the pair unbuyable — say so on the button
    // instead of letting the click fail against /cart/add.js.
    if (addBtn) {
      var ok = mainAvailable() && !!partnerVariantId();
      addBtn.disabled = !ok;
      addBtn.setAttribute('aria-disabled', String(!ok));
    }
  }

  if (partnerSel) partnerSel.addEventListener('change', render);

  // The section's own handler resolves the hidden variant id on the same
  // `change` event. Read it on the next frame so we see the updated value
  // rather than the previous variant's.
  if (section.addEventListener) {
    section.addEventListener('change', function () { requestAnimationFrame(render); });
    section.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.durnev-product__swatch, .durnev-product__size')) {
        requestAnimationFrame(render);
      }
    });
  }

  // Variant JSON arrives with the document, but the hidden id input is set by
  // the section's async /products/<handle>.js fetch — re-render shortly after
  // load so the total reflects the resolved variant, not just the first one.
  render();
  setTimeout(render, 800);

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var mainId = mainVariantId();
      var partId = partnerVariantId();
      if (!mainId || !partId) return;

      addBtn.disabled = true;
      var label = addBtn.querySelector('[data-bundle-cta-label]') || addBtn;
      var restore = label.textContent;
      label.textContent = '…';

      // One quantity of each: reading the main qty stepper would silently
      // multiply the partner too, which nobody expects from "додати обидва".
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: mainId, quantity: 1 }, { id: partId, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (j) {
              var d = j.description || j.message || 'Не вдалось додати';
              throw new Error((window.durnevTranslateCartError || function (m) { return m; })(d));
            });
          }
          return r.json();
        })
        .then(function () {
          return fetch('/', { headers: { 'Accept': 'text/html' }, cache: 'no-store' });
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('overlay-cart');
          var current = document.getElementById('overlay-cart');
          if (fresh && current) current.replaceWith(fresh);
          var freshBag = doc.querySelector('[data-cart-count], .durnev-header__bag-count');
          var curBag = document.querySelector('[data-cart-count], .durnev-header__bag-count');
          if (freshBag && curBag) curBag.textContent = freshBag.textContent;
          var trigger = document.querySelector('[data-overlay-open="cart"]');
          if (trigger) trigger.click();

          if (typeof window.fbq === 'function') {
            fbq('track', 'AddToCart', {
              content_ids: [String(mainId), String(partId)],
              content_type: 'product_variant',
              value: (mainPrice() + partnerPrice()) / 100,
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'UAH'
            });
          }
        })
        .catch(function (err) {
          alert(err.message || 'Не вдалось додати комплект до кошика');
        })
        .finally(function () {
          label.textContent = restore;
          render();
        });
    });
  }
})();
